(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;
  const strings = window.rocketStrings?.widgets;
  if (!strings) return;

  function translateWidgets() {
    document.querySelectorAll('.klaviyo-form, [class*="kl-private-reset-css"][role="dialog"], [class*="Teaser-pointer"]').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement.closest('script, style, textarea')) continue;
        const source = node.nodeValue.trim();
        if (strings[source]) node.nodeValue = node.nodeValue.replace(source, strings[source]);
      }
      root.querySelectorAll('[placeholder], [aria-label], [title], [alt]').forEach((element) => {
        ['placeholder', 'aria-label', 'title', 'alt'].forEach((attribute) => {
          const value = element.getAttribute(attribute);
          if (strings[value]) element.setAttribute(attribute, strings[value]);
        });
      });
      const label = root.getAttribute('aria-label');
      if (strings[label]) root.setAttribute('aria-label', strings[label]);
    });
    document.querySelectorAll('.jdgm-sort-dropdown-label').forEach((element) => {
      if (element.textContent !== strings.sortBy) element.textContent = strings.sortBy;
    });
    document.querySelectorAll('.jdgm-widget a, .jdgm-widget button').forEach((element) => {
      if (element.textContent.trim() === 'Write a review') element.textContent = strings.writeReview;
    });
    document.querySelectorAll('.jdgm-widget [aria-label], .jdgm-widget [alt]').forEach((element) => {
      ['aria-label', 'alt'].forEach((attribute) => {
        const source = element.getAttribute(attribute);
        if (!source) return;
        const translated = source
          .replace(/^Average rating is (.+) stars$/, strings.averageRating)
          .replace(/^(\d+) star review$/, strings.starReview)
          .replace(/^(.*) reviews with (\d+) star rating$/, strings.ratingFilter)
          .replace(/^Verified Checkmark$/, strings.verified);
        if (source !== translated) element.setAttribute(attribute, translated);
      });
    });
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      translateWidgets();
    });
  });
  observer.observe(document.body, {childList: true, subtree: true});
  translateWidgets();
})();
